import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    isExpired: {
      color: theme.palette.error.main,
    },
  };
};
